import axios from 'axios'

let sitePromise
let site

export function loadSiteContext () {
  if (!sitePromise) {
    sitePromise = axios.get('/api/match/site', { timeout: 10000 }).then(response => {
      const data = response.data
      if (!data || data.code !== 200 || !data.result) throw new Error('赛事域名配置不可用')
      site = data.result
      return site
    }).catch(error => {
      sitePromise = null
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        site = { mode: 'local' }
        return site
      }
      throw error
    })
  }
  return sitePromise
}

export function currentMatchId (route) {
  return String((site && site.mode === 'bound' && site.matchId) || route.query.matchId || '')
}
